/**
 * String based feature flags
 *
 * Insert new flags alphabetically inside the keep-sorted block, with a date and a description.
 *
 * https://docs.launchdarkly.com/home/getting-started/feature-flags
 */

export const STRING_FEATURE_FLAGS = [
  // keep-sorted:begin
  // Show Modernloop Candidate portal maintenance screen to all users
  'cp_show_maintenance_screen',

  // Show Modernloop maintenance screen to all users
  'user_show_maintenance_screen',
  // keep-sorted:end
] as const;

export type FeatureFlagString = (typeof STRING_FEATURE_FLAGS)[number];
